import type { Image, Link } from '#app/types'
import type { StrapiImage, StrapiLink } from '#app/types/strapi'

export function mapLink(link: StrapiLink): Link {
  let url = ''
  let openInNewTab = false

  if (link.url) {
    url = link.url
    openInNewTab = true
  }

  if (link.asset.data) {
    url = link.asset.data.attributes.url
    openInNewTab = true
  }

  if (link.link.data) {
    url =
      link.link.data.attributes.slug === 'home'
        ? '/'
        : `/${link.link.data.attributes.slug.toLocaleLowerCase()}`
  }

  return {
    url,
    openInNewTab,
    id: link.id,
    text: link.text,
    icon: link.icon,
  }
}

export function mapImage(image: StrapiImage | null): Image {
  if (!image) {
    return {
      url: '',
      alt: 'Image not found',
    }
  }
  return {
    url: image.url,
    alt: image.alternativeText ?? '',
  }
}
